/** @format */
import BlogListMedium from "@Web/Blocks/BlogListMedium";
import { Box, Typography } from "@mui/material";
import { useLocales } from "locales";

const MostViewedArticles = (props) => {
  const { t } = useLocales();
  return (
    <Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={{ xs: "flex-start", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
        marginBottom={4}
      >
        <Box>
          <Typography fontWeight={700} variant={"h6"} gutterBottom>
            {t("mostViewedArticles")}
          </Typography>
          <Typography color={"text.secondary"}>{t("heresWhatPeopleAreReading")}</Typography>
        </Box>
      </Box>
      <BlogListMedium {...props} />
    </Box>
  );
};

export default MostViewedArticles;
